exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "form-errors-summary .border{border:1px solid #c8175e;border-radius:6px;display:block;margin:0 auto 20px;margin-bottom:20px;min-height:56px;padding:20px 20px 8px;position:relative}form-errors-summary .icon-warning{color:#c8175e;font-size:34px;left:20px;position:absolute;top:10px}form-errors-summary p,form-errors-summary ul{padding-left:50px}form-errors-summary ul{list-style:none}form-errors-summary li,form-errors-summary p{color:#c8175e;font-family:ArialMT;font-size:15px;line-height:1.13}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/components/formErrorsSummary/formErrorsSummary.scss
// module id = 697
// module chunks = 0